import { Row } from 'react-table';
import { ContributionDetailsResponse } from 'services/requests';
import {
  ContributionDetailTableSign,
  MapData,
  columns,
} from 'screens/Contributions/ContributionDetails/ContributionDetails.columns';
import Table from 'components/Table';

type Props = {
  contributionDetailsData?: ContributionDetailsResponse;
  items?: MapData;
  onDetailClick: (row: Row<ContributionDetailTableSign>) => void;
};

const RenderContributionDetailsTable = ({
  contributionDetailsData,
  items,
  onDetailClick,
}: Props): JSX.Element | null => {
  if (!items || (items && items?.length === 0)) return null;

  return (
    <Table<ContributionDetailTableSign>
      columns={columns}
      data={items}
      onRowClick={onDetailClick}
    />
  );
};

export default RenderContributionDetailsTable;
